export default __webpack_public_path__ + "static/media/ic-standup.81f7a550.svg";